import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";

import { MagnifyingGlassIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid'
import {
  Bars3Icon,
  BellIcon,
  CogIcon,
  CreditCardIcon,
  KeyIcon,
  SquaresPlusIcon,
  UserCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'

import { Field, Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { BuildingOfficeIcon, UserIcon, UsersIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Interest } from "@/views/base/user/Interest";
import {storeBaseSetting2, removeBaseSetting} from "@/reducers/Settings";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import { FieldHolder } from "@/components/holders/FieldHolder";


import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'


export function ContactTypeView({...props}) {
    const [settings, setSettings] = useState((props.SettingsReducer && props.SettingsReducer.settings_contacttypes) ? props.SettingsReducer.settings_contacttypes : []);
    const [action, setAction] = useState("");

const contact_type_items = [
  { id:"C", title: 'Klanten', description: 'Conact type alleen voor uw klanten', current: false },
  { id:"U",title: 'Team leden', description: 'Contact type alleen voor uw team leden', current: false },
  { id:"U,C", title: 'Beide', description: 'Contact type voor uw klanten en team leden', current: false },
];
const [selected, setSelected] = useState()
    
    const getLbl = (selectedId:String) => {
        for(let i in contact_type_items) {
            if(contact_type_items[i]["id"] == selectedId) {
                return contact_type_items[i]["title"];
            }
        }
        return contact_type_items.map((item,selectedId)=> {
            if(""+item.id == ""+selectedId) {
                return item.title;
            }
        });
    }


    const editItem = (event, item) => {
        setSelected(item.main_type)
        setAction( item.key );
    }
    const cancel = (event) => {
        let newArray = [...props.SettingsReducer.settings_contacttypes];
        setSettings( newArray );
        setAction( "" );
    }
    const addItem = (event) => {
        let key = "NEW";
        let obj = {key:key, name: "", main_type: "U,C"};
        let newArray = [...settings, obj];
        setSettings( newArray );
        setAction( key );
        return false;
    }
    
    const saveItem = (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        const data = new FormData(event.target);
        const values = Object.fromEntries(data.entries());
        store.dispatch( storeBaseSetting2( {data: values, type: "contacttype"} ) );

//        setAction( "" );
        return false;

    }    

    const removeItem = (event, item) => {
        event.preventDefault();
        event.stopPropagation();
    
        store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));

//        setAction( "" );
        return false;

    }    
    const changeOption = (event) => {
        setSelected(event);
        
    }
const confirmedRemoveHandler = (props) => {
    store.dispatch( removeBaseSetting({data: props.item, type: "contacttype"}) );
    store.dispatch(hideModal(null));
}
    
//    const {settings_vatrates} = SettingsReducer;
         return (
<form onSubmit={saveItem}>
                    {action != ""  &&
                        <input name="key" type="hidden" defaultValue={action} />
                    }


                  <div className="shadow sm:rounded-md">
                    <div className="bg-white px-4 py-6 sm:p-6">
                        {settings && settings.length >= 0 && 
          <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 w-4">
                    <span className="sr-only">Edit</span>
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 w-12">
                    Type
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ">
                    Naam
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {settings.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex">
                        {action == "" &&
                        <>
                        <TrashIcon className="w-3 h-5 cursor-pointer" onClick={() => removeItem(event, item)}/>
                        <PencilIcon className="w-3 h-5 cursor-pointer" onClick={() => editItem(event, item)}/>
                        </>
                        }
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    
                    <div className={(action != "" && action == item.key) ? 'flex z-4' : 'hidden'} >



   <Listbox key={item.key} name="main_type" defaultValue={getLbl(item.main_type)} onChange={changeOption}>
      <div className="relative">
        <div className="inline-flex divide-x divide-indigo-700 rounded-md shadow-sm">
          <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-indigo-600 px-3 py-2 text-white shadow-sm">
            <CheckIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
            <p className="text-sm font-semibold">{getLbl(selected)}</p>
          </div>
          <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-indigo-600 p-2 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 focus:ring-offset-gray-50">
            <span className="sr-only">Change published status</span>
            <ChevronDownIcon aria-hidden="true" className="h-5 w-5 text-white" />
          </ListboxButton>
        </div>

        <ListboxOptions 
          transition
          className="absolute right-0 z-100 mt-2 w-72 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
        >
          {contact_type_items.map((option) => (
            <ListboxOption
              key={option.id}
              value={option.id}
              defaultChecked={item.main_type == option.id}
              className="group cursor-default select-none p-4 text-sm text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <div className="flex flex-col">
                <div className="flex justify-between">
                  <p className="font-normal group-data-[selected]:font-semibold">{option.title}</p>
                  <span className="text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                    <CheckIcon aria-hidden="true" className="h-5 w-5" />
                  </span>
                </div>
                <p className="mt-2 text-gray-500 group-data-[focus]:text-indigo-200">{option.description}</p>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>


                    </div>
                    {action == "" && 
                    getLbl(item.main_type)
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{getLbl(item.main_type)}</span>
                    }
                    
                    
                    </td>
                    
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {action != "" && action == item.key &&

            <FieldHolder colspan="10" smcolspan="5" label="" id="name" error={props?.state?.error} className="col-span-8">                
                  <input
                    id="name"
                    name="name"
                    type="text"
                    key={'name_input'}
                    defaultValue={item.name}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

                        
                    }
                    {action == "" && 
                    item.name
                    }
                    {action != "" && action != item.key && 
                    <span className="text-gray-200">{item.name}</span>
                    }
                    
                    </td>
                        
                        
                    </tr>                        
                ))}
              </tbody>
            </table>
            }
                    </div>
                    
                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                    {action == "" && 
                      <button
                        onClick={() => addItem(event)}
                        type="button"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Toevoegen
                      </button>
                      }
                      
                    {action != "" &&
                        <>
                      <button
                        type="button"
                        onClick={() => cancel(event)}
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Annuleren
                      </button>
 
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                      >
                        Bewaren
                      </button>
                      </>
                      }
                      
                      
                    </div>
                    
                  </div>
                  
                </form>
    );    
}